/**
 * PA7 Live Orders Popup - JavaScript
 */

// Array of sample orders for PA7
const orders = [
    { name: "Kentray", location: "Chi, IL", product: "PA(7) 1 Bottle", time: "Just now" },  
    { name: "Samuel", location: "NV", product: "PA(7) 1 Bottle", time: "2 minutes ago" },
    { name: "Roman", location: "RI", product: "PA(7) 1 Bottle", time: "5 minutes ago" },
    { name: "Jason", location: "TX", product: "PA(7) 1 Bottle", time: "8 minutes ago" },
    { name: "Jose", location: "TX", product: "PA(7) 1 Bottle", time: "10 minutes ago" },
    { name: "Ricardo", location: "FL", product: "PA(7) 2 Bottles", time: "Just now" },
    { name: "Denise", location: "TN", product: "PA(7) 1 Bottle", time: "14 minutes ago" },
    { name: "Patrick", location: "NJ", product: "PA(7) 1 Bottle", time: "18 minutes ago" },
    { name: "Peter", location: "CA", product: "PA(7) 1 Bottle", time: "21 minutes ago" },
    { name: "Terrence", location: "NC", product: "PA(7) 1 Bottle", time: "27 minutes ago" },
    { name: "Peter", location: "CA", product: "PA(7) 3 Bottles", time: "12 minutes ago" },
    { name: "Johnny", location: "LA", product: "PA(7) 1 Bottle", time: "15 minutes ago" },
    { name: "John", location: "NY", product: "PA(7) 1 Bottle", time: "19 minutes ago" },
    { name: "Caleb", location: "WA", product: "PA(7) 1 Bottle", time: "24 minutes ago" },
    { name: "Christopher", location: "MI", product: "PA(7) 1 Bottle", time: "29 minutes ago" },
    { name: "Peter", location: "FL", product: "PA(7) Bundle", time: "11 minutes ago" },
    { name: "Peter", location: "FL", product: "PA(7) 2 Bottles", time: "11 minutes ago" },
    { name: "Jason", location: "CA", product: "PA(7) Bundle", time: "14 minutes ago" },
    { name: "Jason", location: "CA", product: "PA(7) 2 Bottles", time: "14 minutes ago" },
    { name: "Anthony", location: "CA", product: "PA(7) Bundle", time: "18 minutes ago" },
    { name: "Anthony", location: "CA", product: "PA(7) 2 Bottles", time: "18 minutes ago" },
    { name: "Christopher", location: "FL", product: "PA(7) Bundle", time: "23 minutes ago" },
    { name: "Christopher", location: "FL", product: "PA(7) 2 Bottles", time: "23 minutes ago" },
    { name: "Dylan", location: "FL", product: "PA(7) Bundle", time: "26 minutes ago" },
    { name: "Dylan", location: "FL", product: "PA(7) 2 Bottles", time: "26 minutes ago" },
    { name: "Anthony", location: "CO", product: "PA(7) Bundle", time: "31 minutes ago" },
    { name: "Anthony", location: "CO", product: "PA(7) 3 Bottles", time: "31 minutes ago" },
    { name: "Luis", location: "TX", product: "PA(7) Bundle", time: "38 minutes ago" },
    { name: "Luis", location: "TX", product: "PA(7) 4 Bottles", time: "38 minutes ago" },
    { name: "Shawn", location: "MD", product: "PA(7) Bundle", time: "10 minutes ago" },
    { name: "Shawn", location: "MD", product: "PA(7) 2 Bottles", time: "13 minutes ago" },
    { name: "Brian", location: "CA", product: "PA(7) Bundle", time: "16 minutes ago" },
    { name: "Brian", location: "CA", product: "PA(7) 2 Bottles", time: "19 minutes ago" },
    { name: "Jacob", location: "AZ", product: "PA(7) Bundle", time: "22 minutes ago" },
    { name: "Jacob", location: "AZ", product: "PA(7) 2 Bottles", time: "25 minutes ago" },
    { name: "Mike", location: "ON", product: "PA(7) Bundle", time: "28 minutes ago" },
    { name: "Mike", location: "ON", product: "PA(7) 2 Bottles", time: "31 minutes ago" },
    { name: "Alfredo", location: "TX", product: "PA(7) Bundle", time: "34 minutes ago" },
    { name: "Alfredo", location: "TX", product: "PA(7) 2 Bottles", time: "37 minutes ago" },
    { name: "Matt", location: "AZ", product: "PA(7) Bundle", time: "40 minutes ago" },
    { name: "Matt", location: "AZ", product: "PA(7) 2 Bottles", time: "43 minutes ago" },
    { name: "Doug", location: "MN", product: "PA(7) Bundle", time: "46 minutes ago" },
    { name: "Doug", location: "MN", product: "PA(7) 2 Bottles", time: "49 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="${randomOrder.product.includes('Bundle') 
                    ? 'https://cdn.shopify.com/s/files/1/2443/2395/files/The_Clinical_Pack_Zoom.png?v=1733351351' 
                    : 'https://cdn.shopify.com/s/files/1/2443/2395/files/PA7_mTor_Believer_Zoom.png?v=1733351351'}" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
